import { adjustableDoorCabinetComponents } from './adjustable-door-cabinet.js';
import { applianceWithPowderCoatingComponents } from './appliance-with-powder-coating.js';
import { bottomAdjustableDoorApplianceComponents } from './bottom-adjustable-door-appliance.js';
import { bottomCabinetApplianceComponents } from './bottom-cabinet-appliance.js';
import { bottomCabinetWithApplianceComponents } from './bottom-cabinet-with-appliance.js';
import { bottomCabinetWithoutApplianceComponents } from './bottom-cabinet-without-appliance.js';
import { bottomWallApplianceComponents } from './bottom-wall-appliance.js';
import { bottomWallItemWithBackPanelComponents } from './bottom-wall-item-with-back-panel.js';
import { bottomWallItemWithCustomCountertopComponents } from './bottom-wall-item-with-custom-countertop.js';
import { bottomWallItemWithDefaultCountertopComponents } from './bottom-wall-item-with-default-countertop.js';
import { bottomWallItemWithDefaultToeKickComponents } from './bottom-wall-item-with-default-toe-kick.js';
import { bottomWallItemComponents } from './bottom-wall-item.js';
import { burnerBaseW24Components } from './burner-base-w-24.js';
import { cornerFillerComponents } from './corner-filler.js';
import { countertopWallItemComponents } from './countertop-wall-item.js';
import { drawer33Door66Components } from './drawer-33-door-66.js';
import { endPanelComponents } from './end-panel.js';
import { evoAffinity25GComponents } from './evo-affinity-25-g.js';
import { evoBaseW36Components } from './evo-base-w-36.js';
import { fillerComponents } from './filler.js';
import { fullDoorBaseComponents } from './full-door-base.js';
import { grillBaseComponents } from './grill-base.js';
import { kamadoGrillBaseComponents } from './kamado-grill-base.js';
import { lynxAsadoGriddgleComponents } from './lynx-asado-griddgle.js';
import { lynxKamadoGrillComponents } from './lynx-kamado-grill.js';
import { lynxNapoliPizzaOvenComponents } from './lynx-napoli-pizza-oven.js';
import { lynxProfessionalCocktailStationComponents } from './lynx-professional-cocktail-station.js';
import { lynxProfessionalDoubleBurnerComponents } from './lynx-professional-double-burner.js';
import { lynxProfessionalDoubleTapTowerKitComponents } from './lynx-professional-double-tap-tower-kit.js';
import { lynxProfessionalGrillW30Components } from './lynx-professional-grill-w-30.js';
import { lynxProfessionalGrillW36Components } from './lynx-professional-grill-w-36.js';
import { lynxProfessionalGrillW42Components } from './lynx-professional-grill-w-42.js';
import { lynxProfessionalGrillW54Components } from './lynx-professional-grill-w-54.js';
import { lynxProfessionalGrillComponents } from './lynx-professional-grill.js';
import { lynxProfessionalOutdoorBeverageDispenserW24Components } from './lynx-professional-outdoor-beverage-dispenser-w-24.js';
import { lynxProfessionalOutdoorIceMachineW15Components } from './lynx-professional-outdoor-ice-machine-w-15.js';
import { lynxProfessionalOutdoorRefrigeratorW24Components } from './lynx-professional-outdoor-refrigerator-w-24.js';
import { lynxProfessionalOutdoorRefrigeratorWithGlassDoorW24Components } from './lynx-professional-outdoor-refrigerator-with-glass-door-w-24.js';
import { lynxProfessionalPowerBurnerComponents } from './lynx-professional-power-burner.js';
import { lynxProfessionalRefrigeratorFreezerComboW24Components } from './lynx-professional-refrigerator-freezer-combo-w-24.js';
import { lynxProfessionalRefrigeratorW15Components } from './lynx-professional-refrigerator-w-15.js';
import { lynxProfessionalSingleBurnerComponents } from './lynx-professional-single-burner.js';
import { lynxProfessionalSingleTapTowerKitComponents } from './lynx-professional-single-tap-tower-kit.js';
import { lynxProfessionalTwoDrawerRefrigeratorW24Components } from './lynx-professional-two-drawer-refrigerator-w-24.js';
import { lynxProfessionalWineCellarW15Components } from './lynx-professional-wine-cellar-w-15.js';
import { lynxSedonaDoubleBurnerComponents } from './lynx-sedona-double-burner.js';
import { lynxSedonaGrillW30Components } from './lynx-sedona-grill-w-30.js';
import { lynxSedonaGrillW36Components } from './lynx-sedona-grill-w-36.js';
import { lynxSedonaGrillW42Components } from './lynx-sedona-grill-w-42.js';
import { lynxSedonaGrillComponents } from './lynx-sedona-grill.js';
import { lynxSedonaHoodW36Components } from './lynx-sedona-hood-w-36.js';
import { lynxSedonaHoodW42Components } from './lynx-sedona-hood-w-42.js';
import { lynxSedonaHoodW48Components } from './lynx-sedona-hood-w-48.js';
import { lynxSedonaHoodComponents } from './lynx-sedona-hood.js';
import { lynxSedonaSingleBurnerComponents } from './lynx-sedona-single-burner.js';
import { lynxSinkBaseComponents } from './lynx-sink-base.js';
import { lynxSinkComponents } from './lynx-sink.js';
import { roomItemComponents } from './room-item.js';
import { roomComponents } from './room.js';
import { sinkBaseComponents } from './sink-base.js';
import { threeDrawerBaseComponents } from './three-drawer-base.js';
import { topWallItemComponents } from './top-wall-item.js';
import { trashPulloutBaseComponents } from './trash-pullout-base.js';
import { wallItemComponents } from './wall-item.js';
import { wallComponents } from './wall.js';
export const generatedComponents = [
    ...wallComponents,
    ...roomComponents,
    ...countertopWallItemComponents,
    ...bottomCabinetWithApplianceComponents,
    ...bottomWallItemComponents,
    ...topWallItemComponents,
    ...grillBaseComponents,
    ...lynxProfessionalOutdoorBeverageDispenserW24Components,
    ...lynxProfessionalOutdoorIceMachineW15Components,
    ...roomItemComponents,
    ...wallItemComponents,
    ...bottomWallItemWithBackPanelComponents,
    ...bottomWallItemWithDefaultToeKickComponents,
    ...bottomCabinetWithoutApplianceComponents,
    ...bottomCabinetApplianceComponents,
    ...bottomWallItemWithDefaultCountertopComponents,
    ...bottomWallItemWithCustomCountertopComponents,
    ...adjustableDoorCabinetComponents,
    ...burnerBaseW24Components,
    ...cornerFillerComponents,
    ...drawer33Door66Components,
    ...endPanelComponents,
    ...fillerComponents,
    ...fullDoorBaseComponents,
    ...kamadoGrillBaseComponents,
    ...lynxKamadoGrillComponents,
    ...lynxNapoliPizzaOvenComponents,
    ...lynxProfessionalCocktailStationComponents,
    ...lynxProfessionalGrillW30Components,
    ...lynxProfessionalGrillW36Components,
    ...lynxProfessionalGrillW42Components,
    ...lynxProfessionalGrillW54Components,
    ...lynxProfessionalGrillComponents,
    ...lynxAsadoGriddgleComponents,
    ...lynxProfessionalSingleBurnerComponents,
    ...lynxProfessionalDoubleBurnerComponents,
    ...lynxProfessionalPowerBurnerComponents,
    ...lynxSedonaGrillComponents,
    ...lynxSedonaGrillW30Components,
    ...lynxSedonaGrillW36Components,
    ...lynxSedonaGrillW42Components,
    ...lynxSedonaSingleBurnerComponents,
    ...lynxSedonaDoubleBurnerComponents,
    ...lynxSinkComponents,
    ...evoAffinity25GComponents,
    ...evoBaseW36Components,
    ...sinkBaseComponents,
    ...lynxSinkBaseComponents,
    ...threeDrawerBaseComponents,
    ...trashPulloutBaseComponents,
    ...lynxSedonaHoodComponents,
    ...lynxSedonaHoodW36Components,
    ...lynxSedonaHoodW42Components,
    ...lynxSedonaHoodW48Components,
    ...bottomWallApplianceComponents,
    ...bottomAdjustableDoorApplianceComponents,
    ...lynxProfessionalRefrigeratorFreezerComboW24Components,
    ...lynxProfessionalOutdoorRefrigeratorW24Components,
    ...lynxProfessionalOutdoorRefrigeratorWithGlassDoorW24Components,
    ...lynxProfessionalRefrigeratorW15Components,
    ...lynxProfessionalWineCellarW15Components,
    ...lynxProfessionalTwoDrawerRefrigeratorW24Components,
    ...lynxProfessionalSingleTapTowerKitComponents,
    ...lynxProfessionalDoubleTapTowerKitComponents,
    ...applianceWithPowderCoatingComponents
];

//# sourceMappingURL=index.js.map